import request from '../../request/request';

const get = () => {
  return request(
    {
      url: '/webapi/broadcast/message'
    },
    false
  );
};

const getMultipleMessages = () => {
  return request(
    {
      url: '/api/broadcast/messages/active'
    },
    false
  );
};

// eslint-disable-next-line import/prefer-default-export
export { get, getMultipleMessages };
